// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#dropdown-notifications {
  max-height: 580px;
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/containers/App/Header/Notifications/styles/Notifications.css","webpack://./services/frontend/app/containers/App/Header/Notifications/styles/Notifications.css"],"names":[],"mappings":"AADA;ECEE,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":["#dropdown-notifications {\n  max-height: 580px;\n  overflow-y: auto;\n}\n","#dropdown-notifications {\n  max-height: 580px;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
